import React from 'react';
import { Avatar, AvatarFallback, AvatarImage } from '@/components/ui/avatar';

export const PRIORITY = {
  none: { id: 'Tidak ada', en: 'None', cls: '' },
  low: { id: 'Rendah', en: 'Low', cls: 'bg-sky-50 text-sky-700 border-sky-200' },
  medium: { id: 'Sedang', en: 'Medium', cls: 'bg-amber-50 text-amber-800 border-amber-200' },
  high: { id: 'Tinggi', en: 'High', cls: 'bg-rose-50 text-rose-700 border-rose-200' },
};
export const COVER_COLORS = ['#1B2A6B', '#0F766E', '#2563EB', '#7C3AED', '#DB2777', '#EA580C', '#CA8A04', '#16A34A', '#475569', '#0891B2'];
export const LABEL_COLORS = ['#e11d48', '#f97316', '#ca8a04', '#16a34a', '#0891b2', '#2563eb', '#7c3aed', '#db2777', '#475569'];
export const ACTION_LABEL = {
  card_created: ['membuat kartu', 'created the card'], card_moved: ['memindahkan kartu', 'moved the card'], card_assigned: ['meng-assign', 'assigned'], comment_added: ['berkomentar', 'commented'],
  due_date_set: ['mengatur due date', 'set due date'], attachment_added: ['menambah lampiran', 'added attachment'], attachment_removed: ['menghapus lampiran', 'removed attachment'],
  checklist_added: ['menambah checklist', 'added checklist'], checklist_completed: ['menyelesaikan checklist', 'completed checklist'], checklist_item_added: ['menambah item checklist', 'added checklist item'],
  card_archived: ['mengarsipkan kartu', 'archived the card'], card_restored: ['memulihkan kartu', 'restored the card'], card_completed: ['menandai selesai', 'marked complete'], card_reopened: ['membuka kembali', 'reopened'],
  card_duplicated: ['menduplikasi dari', 'duplicated from'], card_moved_board: ['memindahkan ke board lain', 'moved to another board'], sales_order_linked: ['menautkan Sales Order', 'linked Sales Order'], sales_order_unlinked: ['melepas Sales Order', 'unlinked Sales Order'],
};

export const initials = (name = '') => name.split(' ').filter(Boolean).slice(0, 2).map((w) => w[0]?.toUpperCase()).join('') || '?';
export const fmtDue = (iso, lang = 'id') => (iso ? new Date(iso + 'T00:00:00').toLocaleDateString(lang === 'id' ? 'id-ID' : 'en-US', { day: 'numeric', month: 'short' }) : '');
export const fmtDT = (iso, lang = 'id') => (iso ? new Date(iso).toLocaleString(lang === 'id' ? 'id-ID' : 'en-US', { day: 'numeric', month: 'short', hour: '2-digit', minute: '2-digit' }) : '');
export const dueTone = (c) => {
  if (!c.due_date) return '';
  if (c.completed_at) return 'bg-emerald-50 text-emerald-700 border-emerald-200';
  const d = new Date(c.due_date + 'T00:00:00'); const today = new Date(); today.setHours(0, 0, 0, 0);
  if (d < today) return 'bg-rose-50 text-rose-700 border-rose-200';
  if (d - today < 2 * 86400000) return 'bg-amber-50 text-amber-800 border-amber-200';
  return 'bg-slate-50 text-slate-700 border-slate-200';
};
export const fmtSize = (b) => (b > 1048576 ? `${(b / 1048576).toFixed(1)} MB` : b > 1024 ? `${Math.round(b / 1024)} KB` : `${b || 0} B`);
export const describeActivity = (a, lang) => {
  const [idL, enL] = ACTION_LABEL[a.action] || [a.action.replace(/_/g, ' '), a.action.replace(/_/g, ' ')];
  const m = a.metadata || {};
  const extra = a.action === 'card_moved' ? `${m.from} → ${m.to}` : a.action === 'card_assigned' ? (m.names || []).join(', ') : a.action === 'due_date_set' ? (m.due_date ? fmtDue(m.due_date, lang) : '—')
    : a.action === 'card_moved_board' ? `${m.from_board} → ${m.to_board} / ${m.to_list}` : m.title || m.name || m.text || m.from || m.preview || '';
  return `${lang === 'id' ? idL : enL}${extra ? ` · ${extra}` : ''}`;
};

export const UserAvatar = ({ u, size = 'sm', className = '' }) => (
  <Avatar className={`${size === 'xs' ? 'h-5 w-5 text-[9px]' : size === 'sm' ? 'h-6 w-6 text-[10px]' : 'h-8 w-8 text-xs'} border border-white ${className}`} title={u?.name}>
    {u?.avatar_url && <AvatarImage src={u.avatar_url} alt="" />}
    <AvatarFallback className="bg-[rgba(27,42,107,0.1)] font-semibold text-primary">{initials(u?.name)}</AvatarFallback>
  </Avatar>
);

export const AvatarStack = ({ ids = [], users = {}, max = 3, size = 'sm' }) => {
  const shown = ids.slice(0, max);
  return (
    <div className="flex -space-x-1.5">
      {shown.map((id) => <UserAvatar key={id} u={users[id] || { name: '?' }} size={size} />)}
      {ids.length > max && <span className={`flex items-center justify-center rounded-full border border-white bg-muted font-medium text-muted-foreground ${size === 'xs' ? 'h-5 w-5 text-[9px]' : 'h-6 w-6 text-[10px]'}`}>+{ids.length - max}</span>}
    </div>
  );
};

export const LabelChip = ({ l, small = false, onClick, active = true }) => (
  <button type="button" onClick={onClick} disabled={!onClick} className={`inline-flex items-center rounded-md font-medium text-white transition-opacity ${small ? 'h-2 min-w-[28px] px-0' : 'px-2 py-0.5 text-[11px]'} ${active ? '' : 'opacity-35'}`} style={{ background: l.color }} title={l.name} data-testid={`label-chip-${l.id}`}>
    {!small && l.name}
  </button>
);
